import { render, staticRenderFns } from "./createOrderWareHouse.vue?vue&type=template&id=44abb6bc&scoped=true&"
import script from "./createOrderWareHouse.vue?vue&type=script&lang=js&"
export * from "./createOrderWareHouse.vue?vue&type=script&lang=js&"
import style0 from "./createOrderWareHouse.vue?vue&type=style&index=0&id=44abb6bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44abb6bc",
  null
  
)

export default component.exports